import React from 'react'
import { WhyGlamsquadWrapper } from './weddings/styles'
import { Header2, Header3, Text } from '../styles/Components'

const WhyGlamsquad = ({ reasons, subtitle }) => {
  if (!reasons || !reasons.length) {
    reasons = [
      {
        title: 'Experts in bridal',
        content:
          'Our premier team of bridal-certified beauty pros have completed 12,000+ bridal beauty services.',
      },
      {
        title: 'Here for it all',
        content: `From your engagement photos to the big day, we're here for you every step of the way.`,
      },
      {
        title: 'We make it easy',
        content:
          'Book your trial appointment and our Wedding Concierge will be in touch to plan for your big day.',
      },
    ]
  }

  return (
    <WhyGlamsquadWrapper>
      {subtitle && (
        <Text lineHeight="130%" spacing={0.16} variant='medium'>
          {subtitle}
        </Text>
      )}
      <Header2 lineHeight="138%" align="left">
        Why Glamsquad?
      </Header2>
      <div className="reasons">
        {reasons.map((r, i) => (
          <div className="card" key={i}>
            <Header3 lineHeight="138%" spacing={0.2}>
              {r.title}
            </Header3>
            <Text lineHeight="130%" spacing={0.16}>
              {r.content}
            </Text>
          </div>
        ))}
      </div>
    </WhyGlamsquadWrapper>
  )
}

export default WhyGlamsquad
